import React, { ReactElement } from 'react';
import { classNames } from 'utils/css';

import { TContentProps } from './Content.types';
import styles from './Content.module.scss';

function Content({
  tabContent,
  beforeContent,
  afterContent,
  gutter,
}: TContentProps): ReactElement {
  return (
    <>
      <div
        id="tab-content"
        className={classNames(styles.contentWrapper, gutter && styles.gutter)}
        data-testid="TabContent">
        {beforeContent}
        <div className={styles.tabContent}>{tabContent}</div>
      </div>
      {afterContent}
    </>
  );
}

export default Content;
